<template>
  <div>
    <!-- modal add member ghost -->
    <div class="modal fade" :ref="`modal-add-member-resident`">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              <!-- {{ $t("apartment.deleteApartmentMember") }} -->
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label required" for="">{{
                        $t("customer.fullname")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="residentData.fullName"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.email") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="residentData.email"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.dob") }}</label>
                      <date-picker
                        :placeholder="$t('customer.dob')"
                        :config="dateOptions"
                        v-model="residentData.dob"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{ $t("customer.phone") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="residentData.phone"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("customer.identificationnumber")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="residentData.identificationnumber"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("apartment.relationshipWithOwner")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="residentData.relationshipWithOwner"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("banner.image")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onSelectImgUpload"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                        <span
                          class="btn btn-danger"
                          style="padding: 2px 5px;"
                          @click="onDeleteImg"
                          ><i class="glyphicon glyphicon-trash"></i
                        ></span>
                      </div>
                    </div>
                    <div class="content-border-class attach-file-class">
                      <div
                        v-for="(imgItem, index) in imgList"
                        :key="imgItem + index"
                        style="display: inline-block; padding: 5px;"
                      >
                        <div>
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :id="index"
                            v-model="imgItem.enable"
                          />
                        </div>
                        <div style="width: 100px; height: 100px;">
                          <img
                            :src="
                              isEmptyString(imgItem.urlFile)
                                ? noImgDefault
                                : imgItem.urlFile
                            "
                            alt=""
                            class="staff-img img-responsive"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div
                      class="class-border"
                      style="display: flex; justify-content: space-between; padding: 5px 10px;"
                    >
                      <span style="align-self: center;">{{
                        $t("userExtraInfo.attachFileList")
                      }}</span>
                      <div style="width: fit-content;">
                        <span
                          class="btn btn-primary"
                          style="padding: 2px 5px;"
                          @click="onClickAttachFile"
                          ><i class="fa fa-paperclip " aria-hidden="true"></i
                        ></span>
                        <span
                          class="btn btn-danger"
                          style="padding: 2px 5px;"
                          @click="onClickDeleteAttachFile"
                          ><i class="glyphicon glyphicon-trash"></i
                        ></span>
                      </div>
                    </div>
                    <div class="content-border-class attach-file-class">
                      <div
                        v-for="(attachFileItem, index) in attachFileList"
                        :key="attachFileItem + index"
                        style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: flex"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="index"
                          v-model="attachFileItem.enable"
                        />
                        <label
                          :title="attachFileItem.fileName"
                          class="form-check-label attach-file-name"
                          style="padding-left: 5px;"
                          @click="onClickOpenAttachFile(attachFileItem.urlFile)"
                        >
                          {{ attachFileItem.fileName }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onSave"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal -->
    <!--  -->
    <component-file-pdf-with-file-name
      ref="componentFilePdfWithFileName"
      :titleModal="uploadPdfFileTitle"
      @uploadPdfFileEmit="handleUpdateAttachFileList"
    />
    <!--  -->
    <!-- input file -->
    <input
      :id="`input-img-upload${imgUploadIndex}`"
      class="form-control"
      type="file"
      accept="image/*"
      @click="onOpenInputSelectFile"
      @change="onSelectImg"
    />
  </div>
</template>
<script>
import ComponentFilePdfWithFileName from "@/components/ComponentFilePdfWithFileName.vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import axios from "axios";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  components: {
    ComponentFilePdfWithFileName,
    "date-picker": datePicker
  },
  props: {
    apartment_id: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    relationship_to_id: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    dateOptions: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    // add member
    imgList: [],
    attachFileList: [],
    uploadPdfFileTitle: "",
    // input img
    imgUploadIndex: null,
    imgFileUploadSize: null,
    fileNameData: null,
    residentData: {
      id: 0,
      fullName: null,
      email: null,
      dob: null,
      phone: null,
      identificationnumber: null,
      relationshipWithOwner: null
    },
    media_server: {
      domain: "",
      token: ""
    }
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  computed: {
    ...mapGetters([
      "GET_TOKEN_UPLOAD_DATA"
    ])
  },
  methods: {
    // isEmptyString: function(value) {
    //   return utils.isEmptyString(value);
    // },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    onShowModalAddMemberResident: function() {
      $(this.$refs[`modal-add-member-resident`]).modal("show");
    },
    onHideModalAddMemberResident: function() {
      $(this.$refs[`modal-add-member-resident`]).modal("hide");
    },
    onShowAddNew: function() {
      this.residentData = {
        id: 0,
        fullName: null,
        email: null,
        dob: null,
        phone: null,
        identificationnumber: null,
        relationshipWithOwner: null
      };
      this.attachFileList = [];
      this.imgList = [];
      this.onShowModalAddMemberResident();
    },
    onShowEdit: function(data) {
      this.residentData = {
        id: data.id,
        fullName: data.full_name,
        email: data.email,
        dob: utils.formatSqlDate(data.dob, null, "DD/MM/YYYY"),
        phone: data.phone,
        identificationnumber: data.identificationnumber,
        relationshipWithOwner: data.relationship_note
      };
      let user_img_list = data.user_img_list
      this.imgList = []
      user_img_list.forEach((img, index) => {
        let item = {
          id: img.id,
          urlFile: img.url,
          fileName: img.file_name,
          index: index,
          enable: false
        };
        this.imgList.push(item)
      })
      this.onShowModalAddMemberResident();
    },
    // upload file attach
    onClickAttachFile: function() {
      let attachFileSelect = this.attachFileList.filter(x => x.enable === true);
      if (attachFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.attachFileList.length + 1
        );
      } else if (attachFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(
          attachFileSelect[0]
        );
      } else {
        this.showError();
      }
    },
    onClickDeleteAttachFile: function() {
      this.attachFileList = this.attachFileList.filter(x => x.enable === false);
    },
    handleUpdateAttachFileList: function(data) {
      let item = {
        id: data.id,
        urlFile: data.pdfUrl,
        fileName: data.fileName,
        index: data.index,
        enable: false
      };
      let searchIndex = this.attachFileList.findIndex(
        x => x.index === data.index
      );
      if (searchIndex === -1) {
        this.attachFileList.push(item);
      } else {
        this.attachFileList[searchIndex].id = item.id;
        this.attachFileList[searchIndex].urlFile = item.pdfUrl;
        this.attachFileList[searchIndex].fileName = item.fileName;
        this.attachFileList[searchIndex].enable = item.enable;
      }
    },
    onClickOpenAttachFile: function(url) {
      window.open(url);
    },
    // upload img
    onOpenInputSelectFile: function() {
      $(`#input-img-upload${this.imgUploadIndex}`).val("");
      $(`#input-img-upload${this.imgUploadIndex}`).click();
    },
    onSelectImgUpload: function() {
      let attachFileSelect = this.imgList.filter(x => x.enable === true);
      if (attachFileSelect.length === 0) {
        this.imgUploadIndex = this.imgList.length + 1;
        this.onOpenInputSelectFile();
      } else if (attachFileSelect.length === 1) {
        this.imgUploadIndex = attachFileSelect.index;
        this.onOpenInputSelectFile();
      } else {
        this.showError();
      }
    },
    // img function
    /**
     * Select issuance img
     */
    onSelectImg: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      await this.getResultFile(files[0]);
      this.imgFileUploadSize = files[0].size;
      this.fileNameData = files[0].name;
      await this.uploadPdfFile();
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.pdfFileUpload = file;
    },
    uploadPdfFile: async function() {
      if (this.imgFileUploadSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.pdfFileUpload);
        formData.append("directory", "userFiles");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let urlFile = res.data.domain + res.data.url;
              this.enhandleUpdateImg(urlFile);
              this.imgFileUploadSize = null;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    enhandleUpdateImg: function(urlFile) {
      let imgName = !utils.isEmptyString(urlFile)
        ? urlFile.split("/")
        : null;
      if (this.imgUploadIndex > this.imgList.length) {
        let item = {
          id: 0,
          urlFile: urlFile,
          fileName: imgName,
          index: this.imgUploadIndex,
          enable: false
        };
        this.imgList.push(item);
      } else {
        this.imgList[this.imgUploadIndex].urlFile = urlFile;
        this.imgList[this.imgUploadIndex].fileName = imgName;
      }
    },
    onDeleteImg: function() {
      this.imgList = this.imgList.filter(x => x.enable === false);
    },
    onSave: function() {
      if (utils.isEmptyString(this.residentData.fullName)) {
        this.showError(this.$t("customer.fullname"));
      } else {
        let data = {
          id: this.residentData.id,
          first_name: utils.getFirstLastName(this.residentData.fullName).firstName,
          last_name: utils.getFirstLastName(this.residentData.fullName).lastName,
          dob: utils.formatSqlUtcDate(this.residentData.dob, "DD/MM/YYYY", "YYYY-MM-DD"),
          phone: this.residentData.phone,
          identificationnumber: this.residentData.identificationnumber,
          relationship: this.residentData.relationshipWithOwner,
          imgList: this.imgList,
          attachFileList: this.attachFileList,
          apartmentId: this.apartment_id,
          relationship_to_id: this.relationship_to_id
        };
        if (this.residentData.id === 0) {
          this.POST_APARTMENT_MEMBER(data)
            .then(
              function() {
                this.$emit("callBackResidentFromAddMember", true);
                this.onHideModalAddMemberResident();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "POST_APARTMENT_MEMBER"
    ])
  }
};
</script>

<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}
/*  */
.class-border {
  border: 1px solid #cccccc;
}
.content-border-class {
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}
.staff-img {
  width: 100%;
  max-width: 150px;
  max-height: 150px;
  margin: auto;
  /* height: 150px; */
}
.attach-file-class {
  max-height: 150px;
  overflow: auto;
  padding: 10px;
}
.attach-file-name:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
.img-action {
  justify-content: space-between;
  display: flex;
  margin: 0 5px;
  padding: 0 5px;
}

.action-button:hover {
  text-decoration: underline;
  cursor: pointer;
}

input[type="file"] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentResidentModal.vue